import { and, eq, sql } from "drizzle-orm";
import { stockMovements, settlementMovements, cashMovements, salesOrders } from "@briolin/db";
import type { TestDb } from "@briolin/db/src/testing.js";

type Db = TestDb;

async function sumStock(db: Db, productId: string, warehouseId: string, kind: "physical" | "reserve"): Promise<number> {
  const [row] = await db.select({ total: sql<number>`COALESCE(SUM(${stockMovements.qtyDelta}), 0)::int` })
    .from(stockMovements)
    .where(and(eq(stockMovements.productId, productId), eq(stockMovements.warehouseId, warehouseId), eq(stockMovements.kind, kind)));
  return Number(row?.total ?? 0);
}

// reserved = резерв-движения, чьи заказы ещё открыты
async function reservedOpen(db: Db, productId: string, warehouseId: string): Promise<number> {
  const [row] = await db.select({ total: sql<number>`COALESCE(SUM(${stockMovements.qtyDelta}), 0)::int` })
    .from(stockMovements)
    .innerJoin(salesOrders, sql`${stockMovements.docId} = ${salesOrders.id}`)
    .where(and(
      eq(stockMovements.productId, productId),
      eq(stockMovements.warehouseId, warehouseId),
      eq(stockMovements.kind, "reserve"),
      eq(stockMovements.docType, "sales_order"),
      eq(salesOrders.status, "open"),
    ));
  return Number(row?.total ?? 0);
}

export async function stockBalance(db: Db, productId: string, warehouseId: string) {
  const physical = await sumStock(db, productId, warehouseId, "physical");
  const reserved = await reservedOpen(db, productId, warehouseId);
  return { physical, reserved, available: physical - reserved };
}

export async function settlementBalance(db: Db, counterpartyId: string): Promise<number> {
  const [row] = await db.select({ total: sql<number>`COALESCE(SUM(${settlementMovements.amountDeltaKopecks}), 0)::bigint` })
    .from(settlementMovements)
    .where(eq(settlementMovements.counterpartyId, counterpartyId));
  return Number(row?.total ?? 0);
}

export async function cashBalance(db: Db, cashAccountId: string): Promise<number> {
  const [row] = await db.select({ total: sql<number>`COALESCE(SUM(${cashMovements.amountDeltaKopecks}), 0)::bigint` })
    .from(cashMovements)
    .where(eq(cashMovements.cashAccountId, cashAccountId));
  return Number(row?.total ?? 0);
}
